import { pxToRem } from 'styles/functions'

// same client as lacleamy
export const hiltonquebec = {
  logo_image_url: 'hilton_quebec_new_branding.png',
  logo_height: 70,

  body_background_color: '#f0e9e6',

  button_color: '#002F61',
  button_radius: 10,

  token_hidden: false,
  number_hidden: false,

  title_font: `Hilton Serif`,
  text_font: `Hilton Sans`,
}

// export const hilton_quebec_new_branding = {
//   logo_image_url: 'hilton_quebec_new_branding.png',
//   logo_height: 70,
//
//   body_background_color: '#f0e9e6',
//
//   button_color: '#002F61',
//   button_radius: 10,
//
//   token_hidden: false,
//   number_hidden: false,
//
//   title_font: `Hilton Serif`,
//   text_font: `Hilton Sans`,
// }

// body_background_color: '#104C97',
//   header_border_color: 'transparent',
//
//   logo_image_url: 'hiltonquebec.png',
//   logo_height: 100,
//
//   token_hidden: true,
//   number_hidden: true,
//
//   button_color: '#00A8E1',
//   button_text_color: 'white',
//   button_border_color: '#00A8E1',
//
//   button_hover_color: 'white',
//   button_hover_text_color: '#00A8E1',
//   button_hover_border_color: '#00A8E1',
//
//   button_radius: 4,
//
//   button_text_size: 16,
//   button_text_lineheight: 24,
//   button_text_weight: 700,
//
//   text_font: `'Loew', sans-serif`,
//   text_color: '#121212',
//
//   title_font: `'Loew', sans-serif`,
//   title_size: 28,
//   title_lineheight: 38,
//   title_color: '#104C97',
//   title_weight: 800,
//   title_margin: `${pxToRem(10)} 0 ${pxToRem(10)} ${pxToRem(10)} `,
//
//   subtitle_color: '#104C97',
//   subtitle_size: 24,
//   subtitle_lineheight: 32,
//   subtitle_weight: 800,
//
//   button_half_border_color: '#E3E3E3',
//
//   separator_color: '#E3E3E3',
//
//   footer_border_color: 'transparent',